import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ImportDiaologTableService {
  // Observable string sources
  private mappingDataSource = new Subject<object>();

  // Observable string streams
  public mappingData$ = this.mappingDataSource.asObservable();

  // Service message commands
  public getMappedfileData(d: object): void {
    this.mappingDataSource.next(d);
  }
}
